var echarts = require('echarts/lib/echarts');
export default function getData (data) {
    let dataShadow = []
    let len = data.seriesData.length
    let yMax = Math.max.apply(null, data.seriesData)
    for (var i = 0; i < len; i++) {
      dataShadow.push(yMax);
    }
    return  {
        tooltip: {
            trigger: 'axis',
            'axisPointer':   {
              type: 'none' 
            },
            formatter: function (params) {
                return params[0].name + '<br />' + params[0].value + '元';
            }
        },
        xAxis: {
            data: data.legendData,
            boundaryGap: false,
            axisLabel: {
                textStyle: {
                    color: '#fff'
                },
                formatter: function (value, idx) {
                  var date = new Date(value);
                  return idx === 0 ? value : [date.getMonth() + 1, date.getDate()].join('/');
                }
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#0c7ffe'
                }
            },
            z: 10
        },
        yAxis: {
            "axisLine":{       //y轴
              "show":false
            },
            "axisTick":{       //y轴刻度线
              "show": false
            },
            "splitLine": {     //网格线
                lineStyle: {
                    color: '#fff',
                    opacity: 0.2,
                    type: 'dotted'
                }
            },
            name: '单位：元',
            nameTextStyle: {
              color: '#fff',
              fontSize: 10,
              padding: [0, 0, 0, 14]
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
        },
        grid: {
          top: '20%',
          bottom: '14%',
          left: '10%',
          right: '8%'
        },
        dataZoom: [
            {
                type: 'inside'
            }
        ],
        series: [
            {
                type: 'line',
                label: {
                    show: false,
                },
                symbol: 'none',
                smooth: true,
                areaStyle: {},
                itemStyle: {
                    normal: {  
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                        [
                            // {offset: 0, color: '#00ffe4'},
                            {offset: 0, color: 'rgba(12, 127, 254, .5)'},
                            // {offset: .8, color: 'rgba(255, 255, 255, 0.08)'}
                            {offset: .8, color: 'rgba(12, 127, 254, 0)'}
                        ]
                      ),  //背景渐变色 
                      lineStyle: {        // 系列级个性化折线样式  
                          width: 2,
                          type: 'solid',
                           color: "#0c7ffe"
                      }
                    }
                },
                emphasis: {
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 1, color: '#0c7ffe'}
                            ]
                        )
                    }
                },
                data: data.seriesData,
                barWidth: 10
            }
        ]
    }
  }


// WEBPACK FOOTER //
// ./src/views/dataIndex/data/transactionFlow.js